import axios from '../../../axios';
import { ILocation } from '../../../types';
import { ActivityLogDTO } from '../types/ActivityLogDTO';
import ClientBulkUploadDTO from '../types/ClientBulkUploadDTO';
import ClientDTO from '../types/ClientDTO';
import ClientOwnerDTO from '../types/ClientOwnerDTO';
import ClientRequestDTO from '../types/ClientRequestDTO';
import ClientStatusDTO from '../types/ClientStatusDTO';
import { DirectHireSearchRequestDTO } from '../types/DirectHireSearchRequestDTO';
import IClientIds from '../types/IClientIds';

const url = 'invoicingservice/api/client';
const activityLogUrl = 'invoicingservice/api/activitylog';
const urlForClientStatus = '/invoicingservice/api/clientstatus';

export const getClientList = (clientReq: ClientRequestDTO) =>
  axios.post(`${url}/parent-list`, clientReq);
export const getParentList = () => axios.get(`${url}/parent-list/all`);
export const getClientById = (id: string) => axios.get(`${url}/${id}`);
export const saveAndUpdateClient = (payload: ClientDTO) => axios.post(`${url}/save`, payload);
export const autocompleteClientName = (search: string) =>
  axios.get(`${url}/autocomplete?search=${search}`);

export const autocompleteParentClientName = (search: string, excludeClient?: string | null) =>
  axios.get(
    `${url}/autocomplete-parent?search=${search}${
      excludeClient ? '&excludeClient=' + excludeClient : ''
    }`
  );
export const getChildClientsByParentId = (id: string, pageNo: number, pageSize: number) =>
  axios.get(`${url}/child-clients-by-parent-id/${id}?pageNo=${pageNo}&pageSize=${pageSize}`);
export const getAllClientList = () => axios.get(`${url}/all-list`);
export const uploadBulkClients = (clients: ClientBulkUploadDTO[]) =>
  axios.post(`${url}/upload`, clients);
export const updateStatus = (id: string, client: ClientDTO) =>
  axios.put(`${url}/update-status/${id}`, client);

export const findByName = (name: string) => axios.get(`${url}/get-by-name?name=${name}`);

export const findByLegalName = (legalName: string) =>
  axios.get(`${url}/get-by-legal-name?legalName=${legalName}`);

export const findClientByCountry = (client: ILocation[]) =>
  axios.post(`${url}/get-by-country`, client);

export const findByStatus = (status: string[]) =>
  axios.get(`${url}/get-by-status?status=${status}`);

export const assignParent = (clientIds: string[], parentId: string) =>
  axios.post(`${url}/assign-parent/${parentId}`, clientIds);

export const saveActivityLog = (payload: ActivityLogDTO) =>
  axios.post(`${activityLogUrl}/create-ActivityLog`, payload);

export const getActivityLogs = (id: string) =>
  axios.get(`${activityLogUrl}/getActivitLogList/${id}`);

export const getActivityLogsByEntity = (id: string) =>
  axios.get(`${activityLogUrl}/getActivitLogListByEntity/${id}`);

export const getClientStatusList = () => axios.get(`${urlForClientStatus}/getAllClientStatus`);

export const saveClientStatus = (clientStatus: ClientStatusDTO) =>
  axios.post(`${urlForClientStatus}/create-clientStatus`, clientStatus);
export const getClientDetailsById = (id: string) => axios.get<ClientDTO>(`${url}/getbyid/${id}`);

export const getClientStatusListByVisibility = () =>
  axios.get(`${urlForClientStatus}/getAllClientStatusByVisibility`);

export const getClientStatusById = (id: string) =>
  axios.get(`${urlForClientStatus}/getClientStatusById/${id}`);

export const getRecruiterActivitLogs = (userId: string) =>
  axios.get(`${activityLogUrl}/get-recruiter-activitlog-list/${userId}`);

export const checkAccessToClient = (clientId: string) =>
  axios.get(`/invoicingservice/api/client/check-access?clientId=${clientId}`);

export const getClientByIds = (payload: IClientIds) => axios.post(`${url}/get-by-ids`, payload);

export const getActivitLogsByClientAndClientContacts = () =>
  axios.get(`${activityLogUrl}/get-activitlog-list-by-client-clientcontact`);

export const getAllClientTags = () => axios.get(`${url}/tags`);

export const getClientFromDirectHire = (request: DirectHireSearchRequestDTO) =>
  axios.post(`${url}/search/directhire`, request);

export const updateClientOwner = (clientId: string, owner: ClientOwnerDTO) =>
  axios.put(`${url}/updateowner/${clientId}`, owner);

export const findClientByLinkedinUrl = (linkedinUrl: string) =>
  axios.get(`${url}/get-by-linkedInUrl?linkedInUrl=${linkedinUrl}`);
